import { render, staticRenderFns } from "./BeginnerIconOnboarding.vue?vue&type=template&id=3220d684"
import script from "./BeginnerIconOnboarding.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeginnerIconOnboarding.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3220d684')) {
      api.createRecord('3220d684', component.options)
    } else {
      api.reload('3220d684', component.options)
    }
    module.hot.accept("./BeginnerIconOnboarding.vue?vue&type=template&id=3220d684", function () {
      api.rerender('3220d684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/BeginnerIconOnboarding.vue"
export default component.exports